<template>
    <Card>
        <div>
            <div class="sousuo yl-flex flex_between" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input v-model="name" placeholder="可搜索客户姓名/电话" style="width: 300px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                    <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
                </div>
                <div style="width: 480px ; display: flex; align-items: center; justify-content: space-around;">
                    <span style="color: red;">成本单价</span>
                    <input v-model="unitValue"
                           style="width: 100px; border:1px solid red; border-radius: 5px; color: red;text-align: center; margin-right: 20px"/>
                    <span style="color: red;">结算价格</span>
                    <input v-model="unitPrice"
                           style="width: 100px; border:1px solid red; border-radius: 5px; color: red;text-align: center;"/>
                    <Button class="ivu-btn-circle" @click="saveBatch" type="primary">批量保存</Button>
                </div>
            </div>
            <div class="multiple">
                <div class="child-div">申请时间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>

                </RadioGroup>
            </div>
            <div class="multiple">
                <div class="child-div">媒体代码</div>
                <Select v-model="mediaId" style="width:200px">
                    <Option v-for="item in mediumIdList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <div class="multiple">
                <div class="child-div">下级渠道</div>
                <Select v-model="shopId" style="width:200px">
                    <Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>

            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row,index }" slot="cost">
                        <Input v-model="datas[index].money" style="width: 50px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="price">
                        <Input v-model="datas[index].price" style="width: 50px"/>
                    </template>
                    <template slot-scope="{ row,index }" slot="operation">
                        <div style="text-align: center">
                            <span :data-index="index" style="color: #63B3E6; cursor: pointer;" @click="save">保存</span>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts" :current="page" @on-change="changePage" @on-page-size-change="changeSize"  size="small"
                      show-elevator/>
            </div>


        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
    import {getAllMediumCode, getAllShop, getClientCost, saveClientCost} from "../../api/runSet";

	export default {
        name: "detail_list",
        components: {},

        data() {
            return {
                pageSize: 20,
                pageSizeOpts: [20,50,100],
                unitValue: '',
                unitPrice: '',
                shopId: '0',
                shopList: [
                ],
                mediaId: '0',
                mediumIdList: [
                ],
                modal: false,
                count: 0,
                page: 1,
                name: '',
                timePeriod: '0',
                timePeriodDate: [],
                datas: [],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        "title": "id",
                        "key": "id",
                        "width": 100,
						"align":"center",
                    },
                    {
                        "title": "媒体代码",
                        "key": "medium_code_name",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "所属渠道",
                        "key": "medium_name",
						"align":"center",
                        "width": 100,
                    },
                    {
                        "title": "客户信息",
                        "key": "name",
						"align":"center",
                        "width": 130
                    },
					{
					    "title": "电话号码",
					    "key": "phone",
						"align":"center",
					    "width": 130
					},
                    {
                        "title": "申请时间",
                        "key": "applied_at",
						"align":"center",
                        "width": 150,
                        "sortable": true
                    },
                    {
                        "title": "额度",
                        "key": "loans_money",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "地域",
                        "key": "city",
						"align":"center",
                        "width": 100,
                    },
                    {
                        "title": "分发状态",
                        "key": "status_name",
						"align":"center",
                        "width": 100
                    },
                    {
                        "title": "接收渠道",
                        "key": "shop_name",
						"align":"center",
                    },
                    {
                        "title": "成本",
                        "slot": "cost",
						"align":"center",
                    },
                    {
                        "title": "结算价格",
                        "slot": "price",
						"align":"center",
                    },
                    {
                        "title": "录入状态",
                        "key": "money_status_name",
						"align":"center",
                    },
                    {
                        "title": "结算状态",
                        "key": "count_status_name",
                        filters: [{
                            label: '未扣除商户余额',
                            value: '未扣除商户余额'
                        },
                            {
                                label: '已扣除商户余额',
                                value: '已扣除商户余额'
                            }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.count_status_name == value;
                        }
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        align: "center",
                        "width": 100
                    }
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
        methods: {

            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            initSearch() {
				this.name = '';
				this.mediaId = '';
				this.shopId = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
            },
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllMediumCode(that, data);
				that.mediumIdList = res.data.list;
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
                data.limit = this.pageSize;
				let res = await getClientCost(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			search() {
                this.page = 1;
				this.getList();
			},
			save(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				let id = that.datas[index].id;
				let money = that.datas[index].money;
                let price = that.datas[index].price;
				this.$Modal.confirm({
					title: '确认保存吗？',
					onOk: async () => {
						let res = await saveClientCost(that, {token: that.token, id: id, money: money, price: price});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
            changeSize(e) {
                this.pageSize = e;
                this.getList();
            },
            saveBatch() {
                let that = this;
                let selectTion = this.$refs['table'].getSelection();
                let ids = [];
                selectTion.forEach(function (e) {
                    ids.push(e.id);
                })
                this.$Modal.confirm({
                    title: '确认批量保存客户成本吗？',
                    onOk: async () => {
                        let res = await saveClientCost(that, {token: that.token, id: ids, money: that.unitValue, price: that.unitPrice});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.unitValue = '';
                            that.getList();
                        }
                    }
                })
            }
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
</style>
